module.exports = __webpack_public_path__ + "img/talent_03.adbd5c0d.png";